import React from "react";

// reactstrap components
import {
  Container
} from "reactstrap";

// core components
import ColorNavbar from "components/Navbars/ColorNavbar.js";
import downloadPdfFromJson from "utils/downloadPdfFromJson.js";


function PoliticasPrivacidadWeb() {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("about-us");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("about-us");
    };
  });
  return (
    <>
      <ColorNavbar />
      <div className="main" style={{ marginTop: "10em" }}>
        <div className="section">
          <Container>
            <h3 className="title text-center" style={{ fontFamily: "'Noto Sans SC', sans-serif" }}>
              POliticas Privacidad Web
            </h3>
            <center className="mt-5">
              <a
                href="#politica-privacidad-web"
                role="button"
                style={{ textDecoration: "none !important", cursor: "pointer" }}
                onClick={(e) => {
                  e.preventDefault();
                  downloadPdfFromJson(
                    "/politica-privacidad-web.json",
                    "POLITICA-privacidad-web.pdf"
                  );
                }}
              >
                <img
                  alt="Imagen con referencia Politicas Web"
                  width="80px"
                  src={require("assets/img/sections/pdf.jpg")}
                ></img>
                <h6 className="my-3">POliticas Privacidad Web</h6>
              </a>
            </center>
          </Container>
        </div>
      </div>
    </>
  );
}

export default PoliticasPrivacidadWeb;
